import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrendingSection from './components/TrendingSection';
import CategoryTabs from './components/CategoryTabs';
import ArticleGrid from './components/ArticleGrid';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '吃瓜51 - 最新热门吃瓜爆料聚合平台',
    description: '吃瓜51是专注于热门娱乐爆料、明星八卦、社会热点的吃瓜聚合平台。第一时间汇聚最新瓜料、独家内幕。',
    url: 'https://chigua51.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '吃瓜51',
      url: 'https://chigua51.com',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <TrendingSection />
          <CategoryTabs />
          <ArticleGrid />
        </main>
        <Footer />
      </div>
    </>
  );
}